module.exports = __webpack_public_path__ + "assets/images/spain-icon-b30c03670d4c44eda144aa6adf7d6b3d.svg";